import React from "react";
import { OpenForDays } from "./Statics/OpenForDays.js";
import { SubStatus } from "./Statics/SubStatus.js";
import { OriginPoint } from "./Statics/OrginPoint.js";
import { ResolutionTime } from "./Statics/ResolutionTime.js";
import { ResolutionCount } from "./Statics/ResolutionCount.js";
import { SlaAlert } from "./Statics/SlaAlert.js";
import { PrimaryAreas } from "./Statics/PrimaryComplaintAreas.js";
import { ComplaintKpi } from "./ComplaintKpi/index.js";
import IndiaMap from "../../Components/Map/Map.jsx";

const Complaint = () => {
  return (
    <div className="flex flex-col flex-grow gap-2 w-full">
      <div className="px-2">
        <ComplaintKpi />
      </div>
      <section className="md:grid grid-cols-3 gap-4 mx-2 sm:block">
        <div className="bg-white rounded-md lg:block md:grid md:grid-cols-[2fr_auto_1fr]">
          <OpenForDays />
          <div className="m-1 border border-gray-300"></div>
          <SubStatus />
        </div>
        <div className="lg:block md:grid md:grid-cols-[2fr_auto_1fr]">
          <div className="bg-white rounded-md w-full h-[80px] mt-0 md:mt-0 ">
            <SlaAlert />
          </div>
          <div className="bg-white rounded-md h-[21rem]  w-full mt-2 relative">
            <IndiaMap />
          </div>
        </div>
        <div className="bg-white rounded-md lg:block md:grid md:grid-cols-[2fr_auto_1fr] mt-2 md:mt-0">
          <ResolutionTime />
          <div className="m-1 border border-gray-300"></div>
          <OriginPoint />
        </div>
      </section>
      <section className="md:grid grid-cols-3 gap-4 mx-2 mb-5 sm:block mt-2 md:mt-0">
        <div className="col-span-2 bg-white rounded-md">
          <ResolutionCount />
        </div>
        <div className="bg-white rounded-md flex items-center justify-center mt-2 md:mt-0">
          <PrimaryAreas />
        </div>
      </section>
    </div>
  );
};

export default Complaint;
